export default __webpack_public_path__ + "static/9-b012d12155636a51443453985788a3dd.webp";